<div class="loading">
  <ng-lottie [options]="loadingConfig" [width]="width" height="height">
  </ng-lottie>
</div>